
<template lang="pug">
  .subscriptions
    subscription-edit( v-if="subscription" v-bind="{ subscription }" )
    div( v-else )
      h2.title Upcoming Orders
      div( v-if="subscriptions === null") Loading...
      div( v-else-if="subscriptions.length === 0" ) No subscriptions!
      div( v-else )
        div( v-for="subscription_item of subscriptions" )
          subscription( v-bind="{ subscription: subscription_item, buttons: true }" )
</template>

<script>
  import Subscription from './Subscription.vue';
  import SubscriptionEdit from './SubscriptionEdit.vue';

  export default {
    name: 'Subscriptions',

    components: {
      Subscription,
      SubscriptionEdit,
    },

    props: {
    },

    setup() {
    },

    async mounted() {
      const storefrontAccessToken = this.$parent.storefrontAccessToken;

      // Fetch products
      const that = this;
      this.products = {};
      fetch('/api/2023-04/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontAccessToken // public token from headless app
        },
        body: `{"query":"{
          products(first: 50) {
            edges {
              node {
                id
                handle
                title
                featuredImage {
                  url
                }
              }
            }
          }
        }"}`
      }).then((data) => data.json()).then((data) => {
        data.data.products.edges.forEach((e) => {
          const id = e.node.id.substr(22);
          that.products[id] = {
            id,
            image: e.node.featuredImage.url
          }
        });
        // console.log('Products', that.products)
      });

      await this.load();
    },

    data() {
      return {
        products: null,
        addresses: null,
        subscriptions: null,
        subscription_item: null,
        subscription: null,
      }
    },

    validations () {
      return {
      }
    },

    methods: {
      load: async function() {
        this.addresses = null;
        this.subscription = null;
        this.subscription_item = null;
        this.subscriptions = null;

        try {
          this.session = await recharge.auth.loginShopifyAppProxy();
          if (!this.session.customerId) {
            // no customer - no subscriptions
            this.subscriptions = [];
            return;
          }

          const chargesData = await recharge.charge.listCharges(this.session);
          this.charges = chargesData.charges;
          console.log(this.charges);

          const { subscriptions } = await recharge.subscription.listSubscriptions(this.session, {
            sort_by: 'id-asc',
          });
          this.subscriptions = subscriptions.filter((e) => e.status == 'active');
        } catch(e) {
          console.log(e);
          this.$parent.logout(true);
        }
      },

      edit: function(subscription) {
        this.subscription = subscription;
      },

      cancel: async function(subscription) {
        await recharge.subscription.cancelSubscription(this.session, subscription.id, {
          cancellation_reason: '',
          send_email: true,
        });
        this.load();
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
